// Vendors
import { convertPxsToRems } from '@openbank/cf-ui-framework';
import styled from 'styled-components';

const ErrorAccordionComponentStyled = styled.div`
  align-items: flex-end;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing_200};
`;
ErrorAccordionComponentStyled.displayName = 'ErrorAccordionComponentStyled';

const ErrorAccordionPreComponentStyled = styled.pre`
  background-color: ${({ theme }) => theme.color_comp_footerpage_rwd_bg};
  max-height: ${convertPxsToRems({ pixels: 250, base: 16 })};
  overflow: auto;
  padding: ${({ theme }) => theme.spacing_150};
  border-radius: ${({ theme }) => theme.radius_100};
  width: 100%;
`;
ErrorAccordionPreComponentStyled.displayName = 'ErrorAccordionPreComponentStyled';

export { ErrorAccordionComponentStyled, ErrorAccordionPreComponentStyled };
